import { Button } from '@material-ui/core';
import React from 'react';
import { useHistory } from 'react-router-dom';
import { NavigateNext, NavigateBefore } from '@material-ui/icons/';
import { IAppState } from '../types';
import { isFinalQuestion } from '../utils/progressUtils';
import { AppDispatch } from '../reducers/appReducer';

interface IProps {
  state: IAppState;
  dispatch: AppDispatch;
}

const NavigationButtons = ({ state, dispatch }: IProps) => {
  const history = useHistory();
  const handlePrevClick = () => {
    dispatch({ type: 'decrement' });
    history.push(`${state.activeCard - 1}`);
  };
  if (isFinalQuestion(state)) {
    return (
      <>
        <div>
          <Button
            onClick={handlePrevClick}
            variant="text"
            startIcon={<NavigateBefore />}
          >
            Previous
          </Button>
        </div>
        <div>
          <Button type="submit" variant="outlined" endIcon={<NavigateNext />}>
            Submit
          </Button>
        </div>
      </>
    );
  }
  return (
    <>
      <div>
        {state.activeCard !== 0 && (
          <Button
            onClick={handlePrevClick}
            variant="text"
            startIcon={<NavigateBefore />}
          >
            Previous
          </Button>
        )}
      </div>
      <div>
        {state.activeCard < state.totalCards - 1 && (
          <Button type="submit" variant="outlined" endIcon={<NavigateNext />}>
            next
          </Button>
        )}
      </div>
    </>
  );
};

export default NavigationButtons;
